import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Alert, Table  } from 'reactstrap'
import { handleGraphQLErrors } from '../../utils'
import { gql } from '@apollo/client'
import Spinner from '../Spinner/Spinner.js'
import { GET_LOG_FILE_QUERY } from '../../graphql.js'

export const GET_LOG_FILE = gql(GET_LOG_FILE_QUERY)

export default function LogFile(props) {
  console.log('LogFile rendered: ', props)

  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const fileInfo = JSON.parse(params.get('fileInfo'))
  const [showSpinner, setShowSpinner] = useState(false)
  const [fileLines, setfileLines] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function fetchFileLines() {
      console.log('LogFile.useEffect.fetchFileLines')
      try {
        setShowSpinner(true)
        const { data, errors } = await window.apolloClient.query({ query: GET_LOG_FILE, variables: { fileInfo: fileInfo } })
        if (data.getLogFile) {
          //console.log(data.getLogFile)
          setfileLines(data.getLogFile)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setShowSpinner(false)
      }
    }
    if (!fileLines && graphQLErrors.length === 0) {
      fetchFileLines()
    }
  }, [fileInfo, fileLines, graphQLErrors])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger" style={{ marginTop: '50px'}}>{graphQLErrors[0].message}</Alert>
  } else if (showSpinner) {
    return <Spinner />
  } else if (fileLines) {
    const rows = []
    let lineNumber = 0
    for (let line of fileLines) {
      let lineText = line
      if (fileInfo.json) {
        if (line.message) {
          lineText = line.message
        } else {
          lineText = ''
        }
      }
      if (lineText) {
        rows.push(<pre key={lineNumber++} style={{ margin: '0'}}>{lineText}</pre>)
      }
    }
    return (
      <div style={{ textAlign: 'center', height: '100%', overflow: 'auto', padding: '10px' }}>
        <div style={{ textAlign: 'center', padding: '10pxs' }}>
          <Table bordered size="sm" style={{ width: 'auto', margin: 'auto' }}>
            <thead>
              <tr><td>{fileInfo.name}</td></tr>
            </thead>
            <tbody>
              <tr><td style={{ textAlign: 'left' }}>{rows}</td></tr>
            </tbody>
          </Table>
        </div>
      </div>
    )
  }
  return ''
}
